import { InfoOutlinedIcon } from "@l2r-front/l2r-icons"
import {
    styled,
    KpiCard as UiKpiCard,
    KpiError as KpiErrorUi,
    KpiSkeleton as KpiSkeletonUi,
    Tooltip as UiTooltip,
    Typography,
} from "@l2r-front/l2r-ui"

export const KpiCard = styled(UiKpiCard)({
    justifyContent: "flex-start",
    "-webkit-user-drag": "none",
})

export const KpiSkeleton = styled(KpiSkeletonUi)(() => ({
    height: "100%",
    width: "100%",
}))

export const KpiError = styled(KpiErrorUi)(() => ({
    height: "100%",
    width: "100%",
}))

export const Header = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(2),
    width: "100%",
}))

export const Title = styled(Typography)(({ theme }) => ({
    color: theme.palette["common/black_states"].main,
}))

export const Tooltip = styled(UiTooltip)(() => ({
}))

export const InfoIcon = styled(InfoOutlinedIcon)(({ theme }) => ({
    color: theme.palette.primary.main,
    height: 24,
}))

export const Desc = styled(Typography)(({ theme }) => ({
    color: theme.palette["common/black_states"].main,
    marginBottom: theme.spacing(2),
    textAlign: "left",
    width: "100%",
}))

export const ChartContainer = styled("div")(() => ({
    flex: "1 1 auto",
    width: "100%",
}))